import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";

import { appointmentsApi } from "@/api";
import { getLocalTimeZoneId } from "@/common/utils/getLocalTimeZoneId";
import { QueryKey } from "@/query/Query";

export function useAttendanceOverviewQuery(weekStart: Date) {
  return useQuery({
    queryKey: [QueryKey.AttendanceOverview, format(weekStart, "yyyy-MM-dd")],
    queryFn: () => appointmentsApi.getAttendanceOverview({ weekStart, originTimeZoneId: getLocalTimeZoneId() }),
    meta: { loadingScope: "pageContent" },
  });
}
